// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3d6f002b","117":"f1ebabb7","342":"45c33427","396":"f86bacbe","565":"9372619c","652":"20ef9595"}[chunkId] + ".chunk.js";
};